module.exports = "<p class=\"alert-header\">{{msg|e}}</p>\n{% if errorsList is not empty %}\n<ul>\n  {% for error in errorsList %}\n  <li>{{error|e}}</li>\n  {% endfor %}\n</ul>\n{% endif %}\n";
